import { render, staticRenderFns } from "./MordibilitasRajal.vue?vue&type=template&id=5c6a740e"
import script from "./MordibilitasRajal.vue?vue&type=script&lang=js"
export * from "./MordibilitasRajal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6a740e')) {
      api.createRecord('5c6a740e', component.options)
    } else {
      api.reload('5c6a740e', component.options)
    }
    module.hot.accept("./MordibilitasRajal.vue?vue&type=template&id=5c6a740e", function () {
      api.rerender('5c6a740e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/morbiditas-rajal/MordibilitasRajal.vue"
export default component.exports